<div class="checkbox d-flex align-center">
  <input class="checkbox-input"
         #nativeInput
         [ngClass]="{background: controlDisabled}"
         type="checkbox"
         [formControl]="control"
         [indeterminate]="indeterminate"
         [id]="id" />
  <label *ngIf="!contractNumberInput"
         class="checkbox-label d-flex align-center bold-first normalize"
         [for]="id">
    {{ label }}
  </label>

  <label *ngIf="contractNumberInput"
         class="checkbox-label d-flex align-center bold-first"
         [for]="id">
    {{ label }}
  </label>
</div>
